/*
 * This code was copied over from the Mono Repo Common-Library
 * TODO: When the Common-Library gets exported to npm,
 * - Remove this file
 * - Update components to use npm package instead of this file
 *
 */
export interface QueryValueObj {
  [key: string]: any;
}

type QueryKey = string;

interface Preferences {
  exclude?: QueryKey[];
  replaceSlashes?: QueryKey[];
}

export function cleanFormikValues(
  formikValues: QueryValueObj,
  { exclude, replaceSlashes }: Preferences
) {
  const formikCopy = { ...formikValues };

  for (const item in formikCopy) {
    const value = formikCopy[item];
    if (!value || value.length === 0) {
      delete formikCopy[item];
    }
  }

  if (exclude) {
    exclude.forEach(item => {
      delete formikCopy[item];
    });
  }

  if (replaceSlashes) {
    replaceSlashes.forEach(item => {
      const value = formikCopy[item];
      if (value) {
        formikCopy[item] = value.replace(/\//g, "-");
      }
    });
  }

  return formikCopy;
}

export function buildUrlQueryString(formikValues: QueryValueObj): string {
  const queryValues = Object.entries(formikValues);

  if (queryValues.length === 0) {
    return "";
  }

  const queryString = queryValues.map(queryItem => {
    const [field, value] = queryItem;
    if (value) {
      return `${field}=${value}&`;
    }
    return "";
  });

  return `${queryString.join("").slice(0, -1)}`;
}

export default function buildAndCleanQueryString(
  formikValues: QueryValueObj,
  preferences: Preferences = {}
): string {
  const cleanValues = cleanFormikValues(formikValues, preferences);
  return buildUrlQueryString(cleanValues);
}
